import { render, staticRenderFns } from "./editBarcode.vue?vue&type=template&id=71df7774&scoped=true"
import script from "./editBarcode.vue?vue&type=script&lang=ts"
export * from "./editBarcode.vue?vue&type=script&lang=ts"
import style0 from "./editBarcode.vue?vue&type=style&index=0&id=71df7774&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71df7774",
  null
  
)

export default component.exports